export default __webpack_public_path__ + "assets/margin-onboarding-1-e357261a6400754ad4e39fbd9ac9cfbb.png";